<div class="menu">
    <div class="form-area">
        <res-name-description [validateNameRequest]="validateNameRequest" [validateName]="validateName"
            [automationId]="modalAutomationId" [customLabelWidth]="116">
        </res-name-description>

        <div class="modal-row" [hidden]="!isLoadFile">
            <div class="modal-row-column-auto load-file-type-label-class"><label requiredAsterisk for="load-file-profile">Load File Template: </label></div>
            <div class="modal-row-column-max">
                <div class="load-file-profile-area">
                    <select id="load-file-profile" name="load-file-profile" [title]="isTemplateSelectDisabled ? 'Please select a load file first' : ''"
                        [(ngModel)]="selectedLoadFileProfileId" [disabled]="isTemplateSelectDisabled"
                        [attr.data-automation-id]="modalAutomationId + '-load-file-profile-dropdown'">
                        <optgroup label="Project Templates:">
                            <option *ngFor="let profile of fileProfiles" [ngValue]="profile.id"
                                [selected]="selectedLoadFileProfileId === profile.id">{{ profile.name }}
                                {{ profile.defaultProfileText }}</option>
                        </optgroup>
                    </select>
                    <button type="button" class="secondary-button"
                        [attr.data-automation-id]="modalAutomationId + '-load-file-profile-edit-button'"
                        *ngIf="hasLoadFilePermissions"
                         (click)="openSettings('Load File Import')">Edit
                        ...</button>
                </div>
            </div>
        </div>

        <div class="modal-row margin-top-row" [hidden]="!is365Connector && !isGoogleWorkspace">
            <div class="date-range-picker">
                <div class="modal-row-column-auto"><label>Date Range:</label></div>
                <div class="modal-row-column-max show-inline">
                    <res-custom-date-time-picker #dateStart class="date-time-picker" name="dateStart" ngDefaultControl
                        [inputPlaceholder]="defaultDatePlaceholders[0]" (click)="onDateClick($event,'start')"
                        (focusout)="onFocusLost($event,'start');" [(ngModel)]="dateObject.startDate" (ngModelChange)="dateChanged('start', $event)"
                        [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="true" [isEnd]="false"
                        [automationId]="modalAutomationId + '-start-date-time-picker'">
                    </res-custom-date-time-picker>
                    <div class="picker-separator">~~</div>
                    <res-custom-date-time-picker #dateEnd class="date-time-picker" name="dateEnd" ngDefaultControl
                        [inputPlaceholder]="defaultDatePlaceholders[1]" (click)="onDateClick($event,'end')"
                        (focusout)="onFocusLost($event,'end')" [(ngModel)]="dateObject.endDate" (ngModelChange)="dateChanged('end', $event)"
                        [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="false" [isEnd]="true"
                        [automationId]="modalAutomationId + '-end-date-time-picker'">
                    </res-custom-date-time-picker>
                </div>
            </div>
        </div>

        <div class="modal-row smf-type-container" *ngIf="isSmfDataSetModal">
            <div class="modal-row-column-auto"><label for="smf-type">SMF Type: </label></div>
            <div class="modal-row-column-max">
                <div class="index-level-area">
                    <button class="system-metadata"
                        [attr.data-automation-id]="modalAutomationId + '-smf-type-cellebrite-button'" type="button"
                        [ngClass]="smfType === SmfType.Cellebrite ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setSmfType(SmfType.Cellebrite)">
                        <div>Cellebrite</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="smfType !== SmfType.Cellebrite"></i>
                    </button>
                    <button class="file-metadata"
                        [attr.data-automation-id]="modalAutomationId + '-smf-type-slack-button'" type="button"
                        [ngClass]="smfType === SmfType.Slack ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setSmfType(SmfType.Slack)">
                        <div>Slack</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="smfType !== SmfType.Slack"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-row search-terms-row" [hidden]="!isGoogleWorkspace">
            <div class="modal-row-column-auto"><label>Search Terms:</label></div>
            <div class="modal-row-column-max">
                <input type="text" name="search-terms" id="search-terms" [(ngModel)]="dateObject.searchTerms"
                    [attr.data-automation-id]="modalAutomationId + '-search-terms'">
            </div>
        </div>

        <div class="modal-row">
            <div class="modal-row-column-auto"><label for="index-level">Index Level: </label></div>
            <div class="modal-row-column-max">
                <div class="index-level-area">
                    <button class="system-metadata"
                        [attr.data-automation-id]="modalAutomationId + '-system-metadata-button'" type="button"
                        [ngClass]="indexLevelType === IndexLevel.SYSTEM_METADATA ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setIndexLevelType(IndexLevel.SYSTEM_METADATA)">
                        <div>System&nbsp;Metadata</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="indexLevelType !== IndexLevel.SYSTEM_METADATA"></i>
                    </button>
                    <button class="file-metadata"
                        [attr.data-automation-id]="modalAutomationId + '-file-metadata-button'" type="button"
                        [ngClass]="indexLevelType === IndexLevel.FILE_METADATA ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setIndexLevelType(IndexLevel.FILE_METADATA)">
                        <div>File&nbsp;Metadata</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="indexLevelType != IndexLevel.FILE_METADATA"></i>
                    </button>
                    <button class="content-class" [attr.data-automation-id]="modalAutomationId + '-content-button'"
                        type="button"
                        [ngClass]="indexLevelType === IndexLevel.CONTENT ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setIndexLevelType(IndexLevel.CONTENT)">
                        <div>Content</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="indexLevelType !== IndexLevel.CONTENT"></i>
                    </button>
                    <button class="analytic" [attr.data-automation-id]="modalAutomationId + '-analytic-button'"
                        type="button"
                        [ngClass]="indexLevelType === IndexLevel.ANALYTIC ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setIndexLevelType(IndexLevel.ANALYTIC)">
                        <div>Analytic</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="indexLevelType !== IndexLevel.ANALYTIC"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="modal-row" [hidden]="indexLevelType === IndexLevel.DO_NOT_INDEX">
            <div class="modal-row-column-auto"><label for="index-level">Index Settings: </label></div>
            <div class="modal-row-column-max">
                <div class="index-settings-area">
                    <input type="text" name="index-settings" readonly id="index-settings"
                        [(ngModel)]="indexSettingsInput"
                        [attr.data-automation-id]="modalAutomationId + '-index-settings-textarea'">
                    <button type="button" class="secondary-button"
                        [attr.data-automation-id]="modalAutomationId + '-index-settings-edit-button'"
                        (click)="openSettings('Index Settings')" title="Edit Current Project Settings"
                        *ngIf="hasIdxSettingsPermissions">Edit
                        ...</button>
                </div>
            </div>
        </div>

        <div class="modal-row"
            [hidden]="indexLevelType === IndexLevel.DO_NOT_INDEX || indexLevelType === IndexLevel.SYSTEM_METADATA || indexLevelType === IndexLevel.FILE_METADATA">
            <div class="modal-row-column-auto"><label for="pattern-detection">Pattern Detection: </label></div>
            <div class="modal-row-column-max">
                <div class="pattern-detection-area">
                    <res-custom-checkbox
                        [attr.data-automation-id]="modalAutomationId + '-pattern-detection-enabled-checkbox'"
                        [(ngModel)]="isPatternDetectionEnabled" content="Enabled"></res-custom-checkbox>
                    <input type="text" readonly name="pattern-detection-input" id="pattern-detection"
                        [(ngModel)]="patternDetectionInput"
                        [attr.data-automation-id]="modalAutomationId + '-pattern-detection-textarea'"
                        [disabled]="!isPatternDetectionEnabled">
                    <button type="button" class="secondary-button" [disabled]="!isPatternDetectionEnabled"
                        *ngIf="hasPatternsSettingsPermissions"
                        [attr.data-automation-id]="modalAutomationId + '-pattern-detection-edit-button'"
                        (click)="openSettings('Patterns')" title="Edit Current Project Settings">Edit
                        ...</button>
                </div>
            </div>
        </div>

        <div class="modal-row">
            <div class="modal-row-column-auto"><label for="batch-name">Batch Name: </label></div>
            <div class="modal-row-column-max">
                <input type="text" [(ngModel)]="batchName" (focusout)="onBatchNameFocusLost()"
                    [attr.data-automation-id]="modalAutomationId + '-batch-name-input'" maxlength="32">
            </div>
        </div>

        <div class="modal-row">
            <div class="buttonOnly">
                <button type="button" class="secondary-button"
                    [attr.data-automation-id]="modalAutomationId + '-other-legal-discovery-options-button'"
                    (click)="otherLegalDiscoveryOptions()">Other
                    Legal Discovery Options ...</button>
            </div>
        </div>
    </div>

    <!-- <div class="modal-row path-area" [hidden]="isLoadFile" *ngIf="hasAddToProjectPermissions">
        <div class="modal-row-column-auto">
            <res-custom-checkbox [automationId]="modalAutomationId + '-add-to-project-data'"
                [(ngModel)]="addToProjectData" content="Add to Project Data"
                [isDisabled]="indexLevelType === IndexLevel.DO_NOT_INDEX || indexLevelType === IndexLevel.SYSTEM_METADATA || indexLevelType === IndexLevel.FILE_METADATA">
            </res-custom-checkbox>
        </div>
    </div> -->